import { CONTENT_API_GET_TOP_SEARCH } from 'src/utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';
import { buildUrlWithQueryParams, filterParams } from 'src/utils/UrlGenerator';

import { httpService } from '../fetch/HttpService';
import {
  topSearchApiParams,
  TopSearchResponse
} from '../responseTypes/topSearchResponse';

const validateTopSearchData = (data: TopSearchResponse) => {
  let validated = false;
  if (data && Array.isArray(data.hits)) {
    validated = true;
  }
  return validated;
};

const topSearchUrl = (
  countryCode: string,
  contentLanguage: string,
  contentAppropriateAge: number,
  state: string,
  city: string
) => {
  const yesterday = getYesterdaysDate();
  const reqObj: topSearchApiParams = {
    limit: 9,
    version: 7,
    'start-date': yesterday,
    'end-date': yesterday,
    languages: contentLanguage,
    country: countryCode,
    state: state,
    city: city
  };
  if (contentAppropriateAge || contentAppropriateAge === 0) {
    reqObj.age = contentAppropriateAge;
  }
  filterParams(reqObj);
  const url = buildUrlWithQueryParams(`${CONTENT_API_GET_TOP_SEARCH}`, reqObj);
  return url;
};

const getYesterdaysDate = (date = new Date()) => {
  const yesterday = new Date(date.setDate(date.getDate() - 1));

  let month = String(yesterday.getMonth() + 1);
  let day = String(yesterday.getDate());
  const year = String(yesterday.getFullYear());

  if (month.length < 2) month = `0${month}`;

  if (day.length < 2) day = `0${day}`;

  return `${year}-${month}-${day}`;
};

export const fetchTopSearch = async (
  countryCode: string,
  contentLanguage: string,
  contentAppropriateAge: number,
  state: string,
  city: string
) => {
  const url = topSearchUrl(
    countryCode,
    contentLanguage,
    contentAppropriateAge,
    state,
    city
  );
  const headers = [
    HTTP_HEADER_KEYS.X_ACCESS_TOKEN,
    HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN
  ];

  const response = await httpService.fetchApiData({
    url,
    type: HTTP_METHODS.GET,
    headers
  });
  const topSearchDataValidated = validateTopSearchData(response);
  if (topSearchDataValidated) {
    return response.hits;
  }
};
